import { CircularProgress } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getUser, signUpMetamask } from "../../firebase/firebase";
import Homepage from "../homepage/homepage";
import Company from "./dashboardCompany/company";
import User from "./dashboardUser/user";

const Dashboard = () => {
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const [user, setUser] = useState();

  // check when its disconnected
  window.addEventListener("message", function (e) {
    if (e.data.message && e.data.message.action == "disconnect") {
      // handler logic
      navigate("/");
    }
    if (e.data.message && e.data.message.action == "addressChanged") {
      // handler logic
      alert("address changed");
    }
  });

  const getUserData = async () => {
    try {
      const { isCreated, account } = await signUpMetamask();
      if (isCreated) {
        const { userData } = await getUser(account);
        setUser(userData);
        console.log(userData?.transactions);
      } else {
        navigate("/");
      }
      setIsLoading(false);
    } catch (error) {}
  };

  // useeffect
  useEffect(() => {
    getUserData();
  }, []);

  return (
    <>
      {isLoading ? (
        <>
          <div className="h-[100vh] w-full bg-black flex items-center justify-center">
            <CircularProgress />
          </div>
        </>
      ) : (
        <>
          {user?.acct === "com" ? (
            <Company values={user} />
          ) : user?.acct === "per" ? (
            <User values={user} />
          ) : (
            <Homepage />
          )}
        </>
      )}
    </>
  );
};

export default Dashboard;
